import Card from '@mui/material/Card';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import {
  Box,
  CardHeader,
  Divider,
  List,
} from '@mui/material';
import { useTranslation } from 'react-i18next';
import React from 'react';
import STRING_KEYS from '../../../../language/keys';

import ItemsCounter from '../../../../components/ItemsCounter';
import AddButton from '../../../../components/common/buttons/AddButton';
import { Anchor } from '../../../../components/Anchor';
import { VIEW_MODE } from '../../../../consts/enums';
import { KeyAttributesListStyle } from './style';
import { KeyAttributesItem } from './KeyAttributesItem';

const MAX_KEY_ATTRIBUTES = 10;

type AttributesProps = {
  attributes: Attributes[],
  onAddKeyAttributeClick?: () => void,
  onRemoveKeyAttributeClick?: (id: string) => void,
  onKeyAttributeChanged?: (updatedItem: Attributes) => void,
  formErrors?: ErrorsValidatationDefauls, // TODO: Rename errors type
  disabled?: boolean,
  viewMode: ViewMode
}

const TalentKeyAttributes = ({
  attributes,
  onAddKeyAttributeClick,
  onRemoveKeyAttributeClick,
  onKeyAttributeChanged,
  formErrors,
  disabled = false,
  viewMode,
}:AttributesProps): JSX.Element => {
  const {
    card,
    cardDisabled,
    cardHeader,
    cardContent,
    list,
  } = KeyAttributesListStyle;
  const { t: translate } = useTranslation();

  const defineKeyAttributesList = () => (
    <List style={ list }>
      {attributes.map((item:Attributes) => {
        return (
          <KeyAttributesItem
            key={ item.id }
            id={ item.id }
            name={ item.name }
            description={ item.description }
            onRemoveClick={ onRemoveKeyAttributeClick }
            onValueChanged={ onKeyAttributeChanged }
            error={ formErrors?.attributes?.find((error) => error.id === item.id) || null }
            viewMode={ viewMode }
          />
        );
      })}
    </List>
  );

  const canAdd = typeof onAddKeyAttributeClick === 'function' && viewMode === VIEW_MODE.EDITABLE;
  const isAddDisabled = attributes.length === MAX_KEY_ATTRIBUTES;

  const cardStyle = {
    ...card,
    ...(disabled) && cardDisabled,
  };

  return (
    <Card style={ cardStyle }>
      <Anchor id="key-attributes" />
      <Box flexDirection="row" style={ KeyAttributesListStyle.headerBox }>
        <CardHeader
          title={ translate(STRING_KEYS.KEY_ATTRIBUTES) }
          style={ cardHeader }
        />
        <Box style={ KeyAttributesListStyle.itemsCounterWrapper }>
          <ItemsCounter
            counter={ attributes.length }
            total={ MAX_KEY_ATTRIBUTES }
          />
        </Box>
      </Box>
      <Divider />
      {attributes.length > 0 && (
        <CardContent style={ cardContent }>
          {defineKeyAttributesList()}
        </CardContent>
      )}
      <Divider />

      {canAdd && (
        <CardActions>
          <AddButton
            onClick={ onAddKeyAttributeClick }
            disabled={ isAddDisabled }
          />
        </CardActions>
      )}
    </Card>
  );
};

TalentKeyAttributes.defaultProps = {
  onAddKeyAttributeClick: undefined,
  onRemoveKeyAttributeClick: undefined,
  onKeyAttributeChanged: () => { /* noop */ },
  formErrors: {},
  disabled: false,
};

export default React.memo(TalentKeyAttributes);
